
/************
 Multi Digital
 ************/

// jQuery
import $ from "jquery";

// OWL Carousel
import owlCarousel from 'owl.carousel';


// LightGallery
import lightGallery from 'lightgallery';
import lgShare from 'lightgallery/plugins/share';
import lgZoom from 'lightgallery/plugins/zoom';
import lgHash from 'lightgallery/plugins/hash';
import lgFullscreen from 'lightgallery/plugins/fullscreen';

// Headheasive 
import Headhesive from 'headhesive';

window.addEventListener('load', function () {

    // agenda_home - Carousel
    $('.agenda_home .owl-carousel').owlCarousel({
        loop:false,
        margin:30,
        dots:false,
        nav:true,
        autoplay:false,
        smartSpeed: 500,
        autoplayTimeout:2000,
        navRewind:true,
        stagePadding: 0,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:2
            },
            1000:{
                items:3
            }
        }
    })

    $('.artikel_karussell .owl-carousel').owlCarousel({
        loop:true,
        nav:true,
        items:1,
        autoplay:false,
        smartSpeed:450,
        lazyLoad: true
    })

    $('.tipps_carousel .owl-carousel').owlCarousel({
        loop:false,
        margin:30,
        dots:false,
        nav:true,
        autoplay:false,
        smartSpeed: 500,
        autoplayTimeout:2000,
        navRewind:true,
        stagePadding: 0,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:2
            },
            1000:{
                items:3
            }
        }
    })
// Foto/Video Home - Carousel
    $('.agenda_carousel .owl-carousel').owlCarousel({
        loop:false,
        margin:30,
        dots:false,
        nav:true,
        autoplay:false,
        smartSpeed: 500,
        autoplayTimeout:2000,
        navRewind:true,
        stagePadding: 0,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:2
            },
            1000:{
                items:3
            }
        }
    })

    // Foto/Video Home - Carousel
    $('.fotovideo_carousel .owl-carousel').owlCarousel({
        loop:false,
        margin:30,
        dots:false,
        nav:true,
        autoplay:false,
        smartSpeed: 500,
        autoplayTimeout:2000,
        navRewind:true,
        stagePadding: 0,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:2
            },
            1000:{
                items:3
            }
        }
    })
    $( ".owl-prev").html('<i class="fal fa-chevron-left"></i>');
    $( ".owl-next").html('<i class="fal fa-chevron-right"></i>');

    // Tabs
    $('.tabs a').on('click', function (event) {
        event.preventDefault()
        $(this).tab('show')
    })

    // Sticky Header
    var options = {
        offset: '#showHere',
        offsetSide: 'top',
        classes: {
            clone: 'sticky_header--clone',
            stick: 'sticky_header--stick',
            unstick: 'sticky_header--unstick'
        }
    };
    var banner = new Headhesive('.sticky_header', options);

    
    // Light Gallery
    var elements = document.getElementsByClassName('lightgallery');

    for (var i = 0; i < elements.length; i++) {
        lightGallery(elements[i], {
            plugins: [lgShare,lgZoom,lgHash,lgFullscreen],
            selector: '.item',
            download: true,
            thumbnail: false,
            autoplayControls: true,
            autoplay: false,
            zoom: true,
            hash: true,
            share: true,
            pinterest: false,
            fullScreen: true,
            animateThumb: true,
            zoomFromOrigin: false,
            toggleThumb: false,
            mode: 'lg-fade',
            licenseKey: "BC0281CA-B5024C44-94CFC10D-48F52900"
        });
    }

    // Word Count and calculate read time for article.
    const readTimeEl = document.querySelector('.artikel_lesezeit .readtime');
    const articleContent = document.querySelector('.inhalt');
    
    if (readTimeEl !== null && articleContent !== null) {
        const text = articleContent.innerText;
        const wpm = 225;
        const words = text.trim().split(/\s+/).length;
        readTimeEl.innerText = Math.ceil(words / wpm);
    }
});


